import ServiceAPI from '@/lib/serviceApi'
import Vue from 'vue'
const state = {
  allProducts: [],
  cartItems: [],
  order: null,
  servicesList: null,
  serviceProducts: []
};

const mutations = {
  SET_ALL_PRODUCTS (state, products = []) {
    state.allProducts = products
    return state
  },
  SET_CART_ITEMS (state, items = []) {
    state.cartItems = items
    return state
  },
  SET_SERVICE_PRODUCTS (state, items = []) {
    state.serviceProducts = items
    return state
  },
  SET_SERVICES_LIST (state, data = null) {
    return Vue.set(state, 'servicesList', data)
  }
}

const actions = {
  async fetchAllProducts ({ commit }) {
    const { data } = await ServiceAPI.get('products')
    commit('SET_ALL_PRODUCTS', data)
  },

  setCartItems ({ commit }, items) {
    commit('SET_CART_ITEMS', items)
  }
}

const getters = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/services.js